<template src="./Header.html"></template>
<style src="./Header.scss" lang="scss"></style>

<script>
	import Searchbar from '@/components/Searchbar/Searchbar';
	import Button from '@/components/Button/Button';
	import Navigation from '@/components/Navigation/Navigation';
	import Burger from '@/components/Burger/Burger';

	/**
	 * The header of the page.
	 * @vue-data {string} loginButtonImportance The color of the button mapped by importance
	 * @vue-data {string} brand The current brand of the page
	 */
	export default {
		name: 'HpHeader',
		props: {
			hasRegisterButton: Boolean,
			searchbar: Object,
			burgerMenu: Array,
			navigation: Array,
			partnerLinks: Array
		},
		data () {
			return {
				loginButtonImportance: 'accent',
				brand: ''
			};
		},
		created () {
			this.brand = process.env.VUE_APP_BRAND;
			if (this.brand === 'webde') {
				this.loginButtonImportance = 'primary';
			}
		},
		components: {
			'hp-searchbar': Searchbar,
			'hp-button': Button,
			'hp-navigation': Navigation,
			'hp-burger': Burger
		}
	};
</script>
